export default function ServicesSection() {
  const services = [
    {
      icon: 'https://winka.io/wp-content/uploads/2024/01/Sports-Betting.png',
      title: '스포츠 배팅 솔루션',
      description: '운영 시스템을 전자동화하여 수익성과 사용자 참여도를 극대화 합니다.'
    },
    {
      icon: 'https://winka.io/wp-content/uploads/2024/01/Online-Casino.png',
      title: '온라인 카지노 솔루션',
      description: '사용자들의 이용률을 극대화 할 수 있게 설계되어 있습니다.'
    },
    {
      icon: 'https://winka.io/wp-content/uploads/2024/01/Online-Slot-Machine.png',
      title: '온라인 슬롯 솔루션',
      description: '10,000개 이상의 게임, 뛰어난 모바일 접근성을 갖추고 있습니다.'
    },
    {
      icon: 'https://winka.io/wp-content/uploads/2024/01/Poker.png',
      title: '포커 솔루션',
      description: '다양한 포커게임 옵션 및 최첨단 기술을 갖추고 있습니다.'
    },
    {
      icon: 'https://winka.io/wp-content/uploads/2024/01/Bitcoin-Betting.png',
      title: '비트코인 배팅 솔루션',
      description: '다양한 암호화폐, 고급 보안 및 향상된 배팅 경험을 제공합니다.'
    },
    {
      icon: 'https://winka.io/wp-content/uploads/2024/01/Casino-API.png',
      title: '카지노 API',
      description: '라이브카지노, 온라인 슬롯머신, 버추얼 스포츠, 미니게임, 파워볼 등 다양한 API를 제공합니다.'
    },
    {
      icon: 'https://winka.io/wp-content/uploads/2024/01/Gambling-Lincese.png',
      title: '겜블링 라이선스',
      description: '전문적인 법률 서비스를 통해 여러분의 비즈니스가 다음 단계로 나아갈 수 있습니다.'
    },
    {
      icon: 'https://winka.io/wp-content/uploads/2024/01/Full-automated-Korean-payment-system.png',
      title: '한국 결제 시스템',
      description: '독자적인 풀 오토 가상계좌 결제 시스템.'
    },
    {
      icon: 'https://winka.io/wp-content/uploads/2024/01/International-Payment-Systems.png',
      title: '해외 결제 시스템',
      description: '다양한 언어지원, 전자동 프로세스, 10개국 이상 지원.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">레알타드의 토탈 토토 솔루션</h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 mb-12">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 animate-fade-in-up"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-24 h-24 mb-4 flex items-center justify-center">
                  <img 
                    src={service.icon} 
                    alt={service.title}
                    className="w-full h-full object-contain"
                  />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center animate-fade-in">
          <a 
            href="https://t.me/WinkaAM" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            한국인 상담하기
          </a>
        </div>
      </div>
    </section>
  );
}
